import SolutionDefinition from './SolutionDefinition';

export default SolutionDefinition;
